import gql from 'graphql-tag';

export default gql`
  mutation saveAMExportConfig($input: saveAMExportConfigInput!) {
    saveAMExportConfig(input: $input) {
      amExportConfig {
        id
        isNew
        createdDate
        sftpHost
        sftpPort
        sftpUsername
        sftpPassword
        authenticationType
        modifiedBy{
          name
        }
        serverFingerprintEnabled
        sftpFingerprint
        serverFingerprintMismatch
        sftpFingerprintUnconfirmed
        connectionTestSuccess
        connectionTestError {
          message
        }
        lastModified
      }
    }
  }
`;
